import { type FC, useEffect } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { useColorScheme } from "web_myplann/Infrastructure/Themes/ColorSchemeProvider";
import { StandalonePortfolioListLegacy } from "web_myplann/Standalone/StandalonePortfolioListLegacy";
import { StandalonePortfolioListRedesign } from "web_myplann/Standalone/StandalonePortfolioListRedesign";

export const StandalonePortfolioListWrapper: FC = () => {
	const { setMode } = useColorScheme();
	const { hasRight: hasPortfolioRight } = usePortfolioRightOptional();

	useEffect(() => {
		setMode({ paletteMode: "light" }, { persist: false });
	}, [setMode]);

	useEffect(() => {
		const style = document.createElement("style");
		style.textContent = `
			* {
				scrollbar-width: none !important;
				-ms-overflow-style: none !important;
			}
			*::-webkit-scrollbar {
				display: none !important;
			}
			[data-testid="portfolio-list-page"],
			[data-testid="portfolio-list-page-redesign"] {
				padding-top: 0 !important;
			}
		`;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);

	return hasPortfolioRight ? (
		<StandalonePortfolioListRedesign />
	) : (
		<StandalonePortfolioListLegacy />
	);
};
